(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rmw-enquiry-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function initRmwEnquiry(root) {
      if (root.getAttribute('data-rmw-init') === 'true') return;

      var step1 = root.querySelector('[data-step="1"]');
      var step2 = root.querySelector('[data-step="2"]');
      var continueBtn = root.querySelector('[data-role="continue-button"]');
      var fallbackSubmit = root.querySelector('[data-role="fallback-submit"]');
      var backBtn = root.querySelector('.rmw-enquiry__back');
      var toggleButtons = root.querySelectorAll('.rmw-enquiry__toggle-option');
      var phoneField = root.querySelector('[data-field="phone"]');
      var emailField = root.querySelector('[data-field="email"]');
      var phoneInput = root.querySelector('[data-role="phone-input"]');
      var emailInput = root.querySelector('[data-role="email-input"]');
      var sentinelEmail = root.querySelector('[data-role="sentinel-email"]');
      var confirmLabel = root.querySelector('[data-role="confirm-label"]');
      var confirmValue = root.querySelector('[data-role="confirm-value"]');
      var phoneConfirmLabel = root.getAttribute('data-phone-confirm-label') || '';
      var emailConfirmLabel = root.getAttribute('data-email-confirm-label') || '';

      // Progressive enhancement only: if any piece is missing, leave the
      // plain fallback form (both fields, one visible submit button) as-is.
      if (!step1 || !step2 || !continueBtn || !phoneInput || !emailInput || !sentinelEmail) {
        return;
      }

      root.setAttribute('data-rmw-init', 'true');

      var mode = 'phone';

      function applyMode() {
        var isPhone = mode === 'phone';
        toggleButtons.forEach(function (btn) {
          var active = btn.getAttribute('data-mode') === mode;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (phoneField) phoneField.classList.toggle('rmw-enquiry__field--hidden', !isPhone);
        if (emailField) emailField.classList.toggle('rmw-enquiry__field--hidden', isPhone);
        phoneInput.disabled = !isPhone;
        phoneInput.required = isPhone;
        emailInput.disabled = isPhone;
        emailInput.required = !isPhone;
        sentinelEmail.disabled = !isPhone;
      }

      // Now that JS can manage everything, switch on the two-step layout:
      // hide the always-visible fallback submit, reveal Continue instead.
      if (fallbackSubmit) fallbackSubmit.style.display = 'none';
      continueBtn.style.display = '';
      applyMode();

      toggleButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          mode = btn.getAttribute('data-mode');
          applyMode();
        });
      });

      continueBtn.addEventListener('click', function () {
        var activeInput = mode === 'phone' ? phoneInput : emailInput;
        if (!activeInput.value.trim()) {
          activeInput.focus();
          if (activeInput.reportValidity) activeInput.reportValidity();
          return;
        }
        if (confirmValue) confirmValue.textContent = activeInput.value.trim();
        if (confirmLabel) confirmLabel.textContent = mode === 'phone' ? phoneConfirmLabel : emailConfirmLabel;
        step1.classList.add('rmw-enquiry__step--hidden');
        step2.classList.remove('rmw-enquiry__step--hidden');
      });

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          step2.classList.add('rmw-enquiry__step--hidden');
          step1.classList.remove('rmw-enquiry__step--hidden');
        });
      }
    }

    function init() {
      document.querySelectorAll('.rmw-enquiry').forEach(initRmwEnquiry);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
